enum SHARED_URL_QUERY_PARAMETERS {
  ErrorForNotification = "error_for_notification",
  ErrorSocialAuth = "error_auth",
  RedirectTo = "redirect_to",
}

export { SHARED_URL_QUERY_PARAMETERS };
